import { createApp } from '../../node_modules/vue/dist/vue.esm-browser.js';

let app = createApp({
  // 修改模板引擎的花括號
  delimiters: ['${', '}'],

  data() {
    return {
      monthAmount: 30
    }
  },

  computed: {
    diffByYear() {
      return this.computeAmount(1);
    }
  },

  methods: {
    computeAmount: function(years) {
      if (this.isNumeric(this.monthAmount) && this.monthAmount < 1) {
        this.monthAmount = 1;
      }

      if (! this.isNumeric(this.monthAmount)) {
        return '';
      }

      let months = 12 * years;
      let comhere = Math.round(this.monthAmount * 1.03 * months * 100) / 100;
      let diy = Math.round(this.monthAmount * 1.05 * months * 100) / 100;
      let diff = Math.round((diy - comhere) * 100) / 100;

      return {
        diy: diy.toLocaleString(),
        comhere: comhere.toLocaleString(),
        diff: diff.toLocaleString()
      };
    },

    isNumeric: function(value) {
      return /^\d+$/.test(value);
    }
  }
}).mount('#compute-app');
